import { connect } from 'react-redux';
import ProjectView from '../../components/DashboardModal/components/ProjectView/ProjectView';
import {
  fetchDashboardStats,
  fetchDashboardWeeklyStats,
  fetchDashboardReport,
  fetchOperationalAlerts,
  fetchAlertsHistoryQuarterly,
  fetchAlertsLifecycleQuarterly,
  fetchAlertsYearlyTrend,
  updateOperationalAlert,
  fetchOperationalAlertsSettings,
  updateOperationalAlertsSettings,
  fetchCustomerLogo,
  fetchDeviceTypesStatsWeekly,
  updateDashboardProjectName,
  updateProjectPipeCoverage,
} from '../../actions/DashboardActions';
import { fetchLeaksIfNeeded } from '../../actions/AlertsActions';

const mapStateToProps = (state) => ({
  dashboardStats: state.leaksList.dashboard.stats,
  weeklyStats: state.leaksList.dashboard.weeklyStats,
  reports: state.leaksList.dashboard.reports,
  // Add leaks data from the store
  leaksData: state.leaksList.leaksByProject,
  selectedProject: state.leaksList.selectedProject,
  // Add operational alerts data
  operationalAlerts: state.leaksList.dashboard.operationalAlerts,
  // Add alerts history quarterly data
  alertsHistoryQuarterly: state.leaksList.dashboard.alertsHistoryQuarterly,
  // Add alerts lifecycle quarterly data
  alertsLifecycleQuarterly: state.leaksList.dashboard.alertsLifecycleQuarterly,
  // Add alerts yearly trend data
  alertsYearlyTrend: state.leaksList.dashboard.alertsYearlyTrend,
  // Add options from leaksList for proper AlertState mapping
  options: state.leaksList?.optionList?.options,
  // Add operational alerts settings (also contains dashboard display settings)
  operationalAlertsSettings: state.leaksList.dashboard.operationalAlertsSettings,
  // Add customer logo
  customerLogo: state.leaksList.dashboard.customerLogo,
  // Add device types stats weekly
  deviceTypesStatsWeekly: state.leaksList.dashboard.deviceTypesStatsWeekly,
  // Add measurement units
  units: state.local.units,
  unitFactor: state.local.factor,
  // Add user for authorization checks
  user: state.leaksList.user
});

const mapDispatchToProps = {
  fetchDashboardStats,
  fetchDashboardWeeklyStats,
  fetchDashboardReport,
  fetchLeaksIfNeeded,
  fetchOperationalAlerts,
  fetchAlertsHistoryQuarterly,
  fetchAlertsLifecycleQuarterly,
  fetchAlertsYearlyTrend,
  updateOperationalAlert,
  fetchOperationalAlertsSettings,
  updateOperationalAlertsSettings,
  updateDashboardProjectName,
  updateProjectPipeCoverage,
  fetchCustomerLogo,
  fetchDeviceTypesStatsWeekly
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectView);